<template>
  <BaseCustomizeMetal componentCode="BA" useGodNameVerticalText />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalBA",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  img {
    // 因金牌的形狀是垂直的，以高 100% 為標準撐開
    width: auto !important;
    height: 100%;
  }
  .metal-text {
    top: 59px;
    left: 205px;
    @include betweenTableTablePro {
      transform: scale(0.8);
      top: 26px;
      left: 153px;
    }
    @include table {
      transform: scale(0.7);
      top: 7px;
      left: 129px;
    }
    @include phone {
      transform: scale(0.64);
      top: -4px;
      left: 113px;
    }
  }
  .templeName {
    height: 50px;
    width: 100px;
    .textContainer {
      width: 106px;
    }
  }
  .godName {
    width: 78px;
    height: 125px;
    writing-mode: vertical-lr;
    writing-mode: vertical-rl;
    .textContainer {
      width: 78px;
      height: 125px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .gift {
    width: 78px;
    height: 29px;
    .textContainer {
      width: 79px;
    }
  }
}
</style>
